// Footer.jsx
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scrollToHomePageHash } from '../../utils/homePageSectionScroll';
import './Footer.css'; // optional, if you want to style separately

const Footer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleSignUpClick = (event) => {
        event.preventDefault();
        const targetHash = '#HomePage-community-section';
        if (location.pathname === '/' && location.hash === targetHash) {
            scrollToHomePageHash(targetHash);
            return;
        }
        navigate('/#HomePage-community-section');
    };

    const handleContactUsClick = () => {
        const targetHash = '#HomePage-contact-faq-section';
        if (location.pathname === '/' && location.hash === targetHash) {
            scrollToHomePageHash(targetHash);
            return;
        }
        navigate('/#HomePage-contact-faq-section');
    };

    return (
        <footer className="msv-footer">
            <div className="msv-footer-main">
                {/* Brand */}
                <div className="msv-footer-col brand-col">
                    <div className="msv-footer-brand">My<span>Speed</span>Vault</div>
                    <div className="msv-footer-tagline">Your Motorsports Collection, Always Within Reach</div>
                </div>
                {/* Contact Details (with social icons) */}
                <div className="msv-footer-col contact-details">
                    <div className="msv-footer-col-title">Contact</div>
                    <div className="msv-footer-contact-row">
                        <span className="msv-footer-icon" aria-label="email">
                            <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24" style={{verticalAlign: 'middle'}}><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v.01L12 13 4 6.01V6h16zm0 12H4V8.99l8 6.99 8-6.99V18z"/></svg>
                        </span>
                        <a href="mailto:support@myspeedvault.com" className="msv-footer-contact-link">support@myspeedvault.com</a>
                    </div>
                    <div className="msv-footer-social-row">
                        <a href="https://www.facebook.com/profile.php?id=61576860637452" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="msv-footer-social-icon">
                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0"/></svg>
                        </a>
                        <a href="https://www.tiktok.com/@myspeedvault?_t=ZP-8xjpX7wd4mc&_r=1" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="msv-footer-social-icon">
                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.25 2c.414 0 .75.336.75.75v12.5a2.75 2.75 0 1 1-2.75-2.75c.414 0 .75.336.75.75s-.336.75-.75.75a1.25 1.25 0 1 0 1.25 1.25V3.5c0-.414.336-.75.75-.75zm4.5 1.5c.414 0 .75.336.75.75 0 1.933 1.567 3.5 3.5 3.5.414 0 .75.336.75.75v1.5a.75.75 0 0 1-.75.75c-1.21 0-2.36-.37-3.25-1.01v7.51a6.25 6.25 0 1 1-6.25-6.25c.414 0 .75.336.75.75s-.336.75-.75.75a4.75 4.75 0 1 0 4.75 4.75V3.5c0-.414.336-.75.75-.75z"/></svg>
                        </a>
                       
                        <a href="https://www.instagram.com/myspeedvault?igsh=MTk2eXIwZnluZ3A5dg==" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="msv-footer-social-icon">
                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.241 1.308 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.241 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.241-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608.974-.974 2.241-1.246 3.608-1.308C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.775.131 4.602.425 3.635 1.392 2.668 2.359 2.374 3.532 2.315 4.809 2.256 6.089 2.243 6.498 2.243 12c0 5.502.013 5.911.072 7.191.059 1.277.353 2.45 1.32 3.417.967.967 2.14 1.261 3.417 1.32 1.28.059 1.689.072 7.191.072s5.911-.013 7.191-.072c1.277-.059 2.45-.353 3.417-1.32.967-.967 1.261-2.14 1.32-3.417.059-1.28.072-1.689.072-7.191s-.013-5.911-.072-7.191c-.059-1.277-.353-2.45-1.32-3.417C21.05.425 19.877.131 18.6.072 17.32.013 16.911 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
                        </a>
                        <a href="https://x.com/MySpeedVault?s=09" target="_blank" rel="noopener noreferrer" aria-label="X" className="msv-footer-social-icon">
                            <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M4 4h4.7l3.3 4.8L15.3 4H20l-6.1 8.5L20 20h-4.7l-3.3-4.8L8.7 20H4l6.1-8.5L4 4zm4.16 2L12 8.98 15.84 6H17.1l-3.1 4.3L17.1 18h-1.26l-3.1-4.3L6.9 18H5.64l3.1-4.3L5.64 6h1.26z"/></svg>
                        </a>
                    </div>
                </div>
                {/* Quick Links */}
                <div className="msv-footer-col quick-links">
                    <div className="msv-footer-col-title">Quick Links</div>
                    <ul>
                    <li><Link to="/#HomePage-community-section" onClick={handleSignUpClick}>Sign Up</Link></li>
                        <li><Link to="/searchCollectibles">View Collectibles</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                        <li><button type="button" className="msv-footer-link-button" onClick={handleContactUsClick}>Contact Us</button></li>
                    </ul>
                </div>
                {/* Business Hours */}
                <div className="msv-footer-col business-hours">
                    <div className="msv-footer-col-title">Business Hours</div>
                    <div>Site available 24/7!</div>
                    <div>Support: 8 AM - 6 PM EST</div>
                </div>
            </div>
            <div className="msv-footer-bottom">
                <div>
                    &copy; {new Date().getFullYear()} My Speed Vault. All rights reserved.
                </div>
                <div className="msv-footer-bottom-links">
                    <Link to="/privacypolicy">Privacy Policy</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;